<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :width="'50%'"
        height="auto"
        :TitleWindow="'Editable Button Cell Dialog Demo'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            {
                text: $t('Shared.Save'),
                variant: 'primary',
                action: emitEventOK
            }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col md="3" lg="3" sd="3">
                <MdEdit
                    :Label="'Row Key'"
                    :TypeProp="'string'"
                    :Name="'row-key'"
                    :value="row"
                    :Id="'row-key'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col md="3" lg="3" sd="12">
                <MdEdit
                    :Label="'Column Key'"
                    :TypeProp="'string'"
                    :Name="'column-key'"
                    :value="column"
                    :Id="'column-key'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col md="6" lg="6" sd="12">
                <MdEdit
                    :Label="'value'"
                    :TypeProp="'string'"
                    :Name="'column-value'"
                    :value="formattedValue"
                    :Id="'column-value'"
                    :isReadOnly="true"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <MdMemo :Name="'data'" :Rows="'6'" :value="data" :isReadOnly="true" />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.PaymentMethod')"
                    v-bind:Options="paymentTypeOptions"
                    v-bind:Model="editableItem.paymentType"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPaymentType"
                    :isRequired="true"
                    :isValid="isValid('paymentType')"
                    :Name="'payment-type'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.PayReference')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'payment-reference'"
                    v-bind:MaxLengthProp="50"
                    v-model="editableItem.paymentReference"
                    v-bind:Id="'payment-reference'"
                    :isRequired="true"
                    :isValid="isValid('paymentReference')"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('ClaimBatchStatus.payDate')"
                    :Model="editableItem.paymentDate"
                    @input="editableItem.paymentDate = $event"
                    :Id="'payment-date'"
                    :Type="'date'"
                    :isConfirm="false"
                    :isRequired="true"
                    :isValid="isValid('paymentDate')"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('PatientClaimList.AmountPay')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'payment-amount'"
                    v-model.number="editableItem.paymentAmount"
                    v-bind:Id="'payment-amount'"
                    :isValid="isValid('paymentAmount')"
                />
            </b-col>
        </b-row>
    </BaseModal>
</template>

<script>
import Utils from '@/common/utils.js';
import EnumService from '@/services/enum.service';
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'EditableDialogCellDemo',
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            default: null
        },
        column: {
            type: String,
            default: null
        },
        row: {
            type: [String, Number],
            default: null
        },
        value: {
            type: [Object, String, Number, Array],
            default: null
        }
    },
    data() {
        return {
            modalId: `modal-${Utils.generateUUID()}`,
            emitCloseEvent: false,
            editableItem: this.value
                ? { ...this.value }
                : {
                      paymentType: null,
                      paymentReference: null,
                      paymentDate: Utils.formatterNowToDate(),
                      paymentAmount: 0
                  },
            paymentTypeOptions: EnumService.PaymentPostPaymentType,
            selectPlaceholder: this.$t('Shared.SelectOptions')
        };
    },
    computed: {
        data() {
            return JSON.stringify(this.item);
        },
        formattedValue() {
            return this.value && (typeof this.value === 'object' || Array.isArray(this.value))
                ? JSON.stringify(this.value)
                : this.value;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.editableItem = newVal
                ? { ...newVal }
                : {
                      paymentType: null,
                      paymentReference: null,
                      paymentDate: Utils.formatterNowToDate(),
                      paymentAmount: 0
                  };
        }
    },
    methods: {
        resetData() {
            this.editableItem = {
                paymentType: null,
                paymentReference: null,
                paymentDate: Utils.formatterNowToDate(),
                paymentAmount: 0
            };
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();
            this.$emit('close');
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update', this.editableItem);
                this.resetData();
            } else {
                bvModalEvent.preventDefault();
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.resetData();
                this.emitCloseEvent = false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            const rules = {
                paymentType: [validationRules.required(this.$t('Msg.RequiredField'))],
                paymentReference: [validationRules.required(this.$t('Msg.RequiredField'))],
                paymentDate: [validationRules.required(this.$t('Msg.RequiredField'))],
                paymentAmount: [validationRules.greaterThan(0, this.$t('Msg.RequiredField'))]
            };

            return this.validateFields(rules, this.editableItem);
        },

        changeDropDownPaymentType(value) {
            this.editableItem.paymentType = value ? value.value : null;
            this.editableItem.paymentReference = value ? value.name : null;
        }
    }
};
</script>
